import TftItemTemplate from "@components/templates/tft/TftItemTemplate";
import React from 'react';

const TftItemPage = () => <TftItemTemplate/>;

export default TftItemPage;
